import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IesterComponent } from 'app/integration/iester/iester.component';
import { LOG_ROUTES } from 'app/integration/message-log/message-log.module';
import { IesterEntryComponent } from 'app/integration/iester/iester-entry.component';
import { DOCS_ROUTES } from './document/document-module';
import { MessageConfigComponent } from 'app/integration/message-config/message-config.component';

const routes: Routes = [
  {
    path: 'integration',
    children: [
      { path: 'iester', component: IesterComponent },
      { path: 'iester-entry', component: IesterEntryComponent },
      { path: 'logs', children: LOG_ROUTES },
      { path: 'message-config', component: MessageConfigComponent },
    ],
  },
  {
    path: 'documents',
    children: DOCS_ROUTES,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IntegrationRoutingModule {}
